import { ICareHome } from '../interfaces/CareHome/ICareHome.ts';

/**
 * Check if all specified features are available in the care home
 * @param careHome - The care home object containing features
 * @param featureNames - Array of feature names to check
 * @returns boolean - true if all features are available, false otherwise
 */
export const hasFeaturePermission = (
  careHome: ICareHome | null | undefined,
  ...featureNames: string[]
): boolean => {
  return featureNames.every(featureName => 
    careHome?.features?.includes(featureName) ?? false
  );
};